import { PersonIcon, RocketIcon } from '@/assets/icons'
import BrandMark from '@components/BrandMark'
import React from 'react'
import {
    AdminButton,
    BackButton,
    HeaderActions,
    HeaderContainer,
    HeaderContent,
    LogoutButton,
    MyProfileButton,
    MyTripsButton,
} from './Header.styles'

interface HeaderProps {
	onLogout?: () => void
	showBackButton?: boolean
	onBackClick?: () => void
	backButtonText?: string
	onMyTripsClick?: () => void
	onMyProfileClick?: () => void
	onAdminClick?: () => void
}

const Header: React.FC<HeaderProps> = ({
	onLogout,
	showBackButton = false,
	onBackClick,
	backButtonText = 'Back',
	onMyTripsClick,
	onMyProfileClick,
	onAdminClick,
}) => {
	return (
		<HeaderContainer>
			<HeaderContent>
				<BrandMark />
				<HeaderActions>
					{onAdminClick && <AdminButton onClick={onAdminClick}>Admin</AdminButton>}
					{onMyTripsClick && (
						<MyTripsButton onClick={onMyTripsClick}>
							<RocketIcon sx={{ fontSize: 18 }} />
							<span>My Trips</span>
						</MyTripsButton>
					)}
					{onMyProfileClick && (
						<MyProfileButton onClick={onMyProfileClick}>
							<PersonIcon sx={{ fontSize: 18 }} />
							<span>My Profile</span>
						</MyProfileButton>
					)}
					{showBackButton && onBackClick && (
						<BackButton onClick={onBackClick}>← {backButtonText}</BackButton>
					)}
					{onLogout && <LogoutButton onClick={onLogout}>Logout</LogoutButton>}
				</HeaderActions>
			</HeaderContent>
		</HeaderContainer>
	)
}

export default Header
